import axios from 'axios';
import { get, post, patch } from 'helpers/api';

const rootPath = '/contacts/people';

export function fetchPerson(id) {
  return get(`${rootPath}/${id}.json`).then(response => response.person);
}

export function searchPeople(searchTerm, onSuccess) {
  axios
    .get(`${rootPath}.json`, { params: { 'q[first_name_or_last_name_or_email_cont]': searchTerm } })
    .then(function (response) {
      onSuccess(response.data.people || []);
    });
}

export function createContact(contact) {
  const primaryCompanyId = contact.company.id;
  const requestData = {
    contactsPerson: { ...contact, primaryCompanyId }
  };

  return post(`${rootPath}.json`, requestData).then(data => data.person);
}

export const updatePerson = person => (
  patch(`${rootPath}/${person.id}.json`, { contactsPerson: person }).then(data => data.person)
);
